import { render } from "./RawMaterial.vue?vue&type=template&id=21fc177f&scoped=true"
import script from "./RawMaterial.vue?vue&type=script&lang=js"
export * from "./RawMaterial.vue?vue&type=script&lang=js"

import "./RawMaterial.vue?vue&type=style&index=0&id=21fc177f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-21fc177f"

export default script